import { Component, Injector } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { DynamicDialogRef, DynamicDialogConfig } from 'primeng/dynamicdialog';
import Swal from 'sweetalert2';
import { VALIDATION_PATTERNS } from '../../utility/validation-patterns';
import { BaseClass } from '../../utility/baseClass';
import { ClientgroupService } from '../../main-layout/clientgroup/clientgroup.service';
import { Utilityservice } from '../../utility/utilityservice.service';

@Component({
  selector: 'app-clientgroupmodal',
  templateUrl: './clientgroupmodal.component.html',
  styleUrls: ['./clientgroupmodal.component.css']
})
export class ClientgroupmodalComponent  extends BaseClass {
saveTitle = 'Add'
  isEdit: boolean = false;
  newgroupupdate: any;
  groupdetails: any = {};
  groupForm: FormGroup;
  CSRFToken = "";
  groupid = null;
  newgroup: any;
  onlyView: any; 
  activeFlag = [
    {
      'labelname': 'Active',
      'value': 'Y'
    },
    {
      'labelname': 'Inactive',
      'value': 'N'
    }
  ]
  constructor(
    public override  injector: Injector,
    private ClientgroupService: ClientgroupService,
    private formBuilder: FormBuilder, 
    private utilityservice:Utilityservice,
    public router: Router,
    public ref: DynamicDialogRef,
    public config: DynamicDialogConfig
  ) {
    super(injector);
    const dataFromParent = this.config.data;
    this.gettoken();
    if (dataFromParent?.title == 'Modify Client Group') {
      this.saveTitle = 'Modify'
      this.isEdit = true;
      this.groupdetails = dataFromParent.datas
    }
  }

  ngOnInit() {
    this.formInitiliaze();
    this.getData(); 
  }

  patchValueForms(data) {
    this.groupid = data[0].groupid;
    this.groupForm.patchValue({ 'groupid': data[0].groupid });
    this.groupForm.patchValue({ 'groupname': data[0].groupname });
    this.groupForm.patchValue({ 'groupinitial': data[0].groupinitial });
    this.groupForm.patchValue({ 'activeflag': data[0].activeflag }); 
  }

  getData() {
    if (this.groupdetails.length !== undefined) {
      this.patchValueForms(this.groupdetails)
    }
  }


  formInitiliaze() {

    this.groupForm = this.formBuilder.group({
      groupname: ['', Validators.compose([
        Validators.required,
        Validators.maxLength(100),
        Validators.pattern(VALIDATION_PATTERNS.SPACERISTRICT),
        Validators.pattern(VALIDATION_PATTERNS.NOTALLOW_SPECIAL_CHAR),
        Validators.pattern(VALIDATION_PATTERNS.ONLYNUMERIC_NOTALLOW)])], 
         groupinitial: ['', Validators.compose([
        Validators.required,
        Validators.maxLength(20),
        Validators.pattern(VALIDATION_PATTERNS.SPACERISTRICT),
        Validators.pattern(VALIDATION_PATTERNS.NOTALLOW_SPECIAL_CHAR),
        Validators.pattern(VALIDATION_PATTERNS.ONLYNUMERIC_NOTALLOW)])], 
      activeflag: ['Y']
    })
  }
  gettoken() {
    this.CSRFToken = '';
    this.utilityservice.getCSRFtoken().subscribe(res => {
      this.CSRFToken = res.csrf;
    })
  }

  public validation_message = {
    groupname: [
      { type: 'required', message: 'Group name is required' },
      { type: 'SPACERISTRICT', message: 'Space is not allowed at the beginning or end.' },
      { type: 'NOTALLOW_SPECIAL_CHAR', message: 'Special characters are not allowed ( % and \' ).' },
      { type: 'placeholder', message: 'Enter Group name' },
      { type: 'maxlength', message: 'Maximum length exceeded' },
      { type: 'ONLYNUMERIC_NOTALLOW', message: 'Only numeric not allowed' }
    ],
     groupinitial: [
      { type: 'required', message: 'Group Initial is required' },
      { type: 'SPACERISTRICT', message: 'Space is not allowed at the beginning or end.' },
      { type: 'NOTALLOW_SPECIAL_CHAR', message: 'Special characters are not allowed ( % and \' ).' },
      { type: 'placeholder', message: 'Enter Group Initial' },
      { type: 'maxlength', message: 'Maximum length exceeded' },
      { type: 'ONLYNUMERIC_NOTALLOW', message: 'Only numeric not allowed' }
    ]
  }
  addClientGroup() {
    const payload = {
      groupname: this.groupForm.get('groupname').value,
       groupinitial: this.groupForm.get('groupinitial').value,  
      activeflag: "Y", 
      csrftoken: this.CSRFToken,
    };  
 
    if (this.saveTitle === 'Modify') {
      this.modifyClientGroup(payload);
    } else {
      if (this.groupForm.invalid) {
        this.validateAllFormFields(this.groupForm);
      } else {
        Swal.fire({
          title: "Do you want to save the changes?",
          showDenyButton: true,
          showCancelButton: true,
          confirmButtonText: "Add",
          denyButtonText: `Don't Save`,
        }).then((value) => {
          if (value.isConfirmed) {
            this.ClientgroupService.addClientGroup(payload).subscribe({
              next: (data) => {
                this.newgroup = data;
                if (this.newgroup.response === 'exists') {
                  Swal.fire("Client Group already exists!", "", "error").then(() => {
                    this.ref.close();
                  });
                } else {
                  Swal.fire("Client Group is added successfully!", "", "success").then(() => {
                    this.ref.close();
                  });
                }
              },
              error: (error) => {
                Swal.fire({
                  title: "Error Saving Client Group",
                  text: error.error.message || "An unexpected error occurred.",
                  icon: "error",
                });
              },
            });
          } else if (value.isDenied) {
            Swal.fire("Changes are not saved", "", "info");
            this.ref.close();
          }
        });
      }
    }
  }

  modifyClientGroup(data: any) { 
    data["groupid"] = this.groupid;
    data["activeflag"] = this.groupForm.get('activeflag').value;
    if (this.groupForm.invalid) {
      this.validateAllFormFields(this.groupForm);
            let invalidFields = [];
      for (const controlName in this.groupForm.controls) {
        if (this.groupForm.controls[controlName].invalid) {
          invalidFields.push(controlName); 
        }
      } 
    } else {
      Swal.fire({
        title: "Do you want to save the changes?",
        showDenyButton: true,
        showCancelButton: true,
        confirmButtonText: "Save",
        denyButtonText: `Don't Save`,
      }).then((value) => {
        if (value.isConfirmed) {
          this.ClientgroupService.modifyClientGroup(data).subscribe({
            next: (response) => {
              this.newgroupupdate = response; 
                if (this.newgroupupdate.response === 'groupExists') {
                  Swal.fire("Client Group Name already exists!", "", "error").then(() => { });
                } else if (this.newgroupupdate.response === 'done') {
                  Swal.fire("Client Group Modified Successfully!", "", "success").then(() => {
                  this.ref.close();
                   });
                } else {
                  Swal.fire(this.newgroupupdate.response ,"", "error").then(() => {
                  });
                }
                
            },
            error: (error) => {
              Swal.fire({
                title: "Error Saving Client Group",
                text: error.error.message || "An unexpected error occurred.",
                icon: "error",
              });
            },
          });
        } else if (value.isDenied) {
          Swal.fire("Changes are not saved", "", "info");
          this.ref.close();
        }
      });
    }
  }
}